import React, { useState, useEffect, useRef } from 'react';
import DatePicker from 'react-datepicker';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import moment from 'moment';
import { isObject } from 'lodash';
import 'react-datepicker/dist/react-datepicker.css';
import FormControl from '@material-ui/core/FormControl';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import get from 'lodash/get';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
// import { useTheme } from '@material-ui/core/styles';
import { breakpoints } from '../../../../../styles/themes/vad/constants';
import useStyles from './Calendar.style';
import clsx from 'clsx';
import Typography from '../../Typography';
import { getYearsAddedToDate } from '../../../../utils/getYearsAddedToDate';
import { useSelector } from 'react-redux';
import { COMPONENT_NAME as TicketBookingLocator } from '../../../../containers/common/TicketBookingForm/locators';

const variantType = null;
const renderText = (text, labelVariant) => (
  <Typography
    variant={variantType}
    component={variantType}
    gutterBottom={false}
  >
    <Text field={text} />
  </Typography>
);

const SingleDatePicker = props => {
  const classes = useStyles();
  const {
    startDate,
    startDateName,
    fieldLabel,
    validationMessage,
    showError,
    isRequired,
    minStartDate,
    labelVariant,
  } = props.data;

  let dateCalendar = '';
  const openDateCalendar = () => dateCalendar.setOpen(true);
  const onStartDateChange = (date, props) => {
    let target = {};
    const { data } = props;
    target.name = data && data.startDateName && data.startDateName.value;
    if (date) {
      target.value = date;
    } else {
      target.value = '';
    }
    props.onDateChange({ target: target });
  };

  const CustomInput = () => {
    return (
      <input
        id={startDateName && startDateName.value}
        name={startDateName && startDateName.value}
        className={classes.datePicker}
        label={fieldLabel && fieldLabel.value}
        value={
          startDate && startDate.value
            ? moment(startDate.value).format('YYYY-MM-DD')
            : ''
        }
      />
    );
  };
  return (
    <FormControl component="fieldset" className={classes.root}>
      <legend />
      <div className={classes.rangeCalendar}>
        <div className={clsx(classes.CalendarWrapper, 'calendarWrapper')}>
          <DatePicker
            onChange={date => onStartDateChange(date, props)}
            startDate={startDate && startDate.value}
            endDate={startDate && startDate.value}
            className={classes.datePicker}
            placeholderText={fieldLabel && fieldLabel.value}
            id={startDateName && startDateName.value}
            name={startDateName && startDateName.value}
            ref={c => (dateCalendar = c)}
            customInput={<CustomInput />}
            popperPlacement={props.position}
            minDate={
              props.shouldSetMinDate
                ? minStartDate && minStartDate.value || new Date()
                : ''
            }
            maxDate={
              props.maxDateYearCount
                ? getYearsAddedToDate(new Date(), props.maxDateYearCount)
                : ''
            }
            {...props}
          />
          <CalendarTodayIcon className="calendarIcon" />
        </div>
        <div
          className={clsx(classes.rangeCalendarPicker, 'rangeCalendarPicker')}
          onClick={() => openDateCalendar()}
        >
          {fieldLabel && (
            <label
              className={
                isObject(startDate && startDate.value)
                  ? classes.labelFilled
                  : 'default-shrink'
              }
              htmlFor={startDateName && startDateName.value}
            >
              <Typography
                variant={labelVariant || variantType}
                component={variantType}
                gutterBottom={false}
              >
                <Text field={{ value: fieldLabel.value }} />
              </Typography>
              {isRequired && isRequired.value && <span> *</span>}
            </label>
          )}
          {startDate && isObject(startDate.value) && (
            <Typography
              variant={variantType}
              component={variantType}
              gutterBottom={false}
            >
              <Text
                field={{
                  value: `${moment(startDate.value).format('DD/MM/YYYY')}`,
                }}
              />
            </Typography>
          )}
          {!startDate.value && fieldLabel && (
            <div className={classes.customPlaceholder}>
              <Text field={fieldLabel} />
            </div>
          )}
          <CalendarTodayIcon className="calendarIcon" />
        </div>
      </div>
      {showError && (
        <div className={classes.errorMsg}>
          {renderText(
            validationMessage &&
            validationMessage.fields &&
            validationMessage.fields.displayText, labelVariant
          )}
        </div>
      )}
    </FormControl>
  );
};

const RangeDatePicker = props => {
  const classes = useStyles();
  const { campaignStart, campaignEnd, applyCampaignValidation } = useSelector(state => state.TicketBookingFormReducer);
  const isMobile = useMediaQuery(`(max-width:${breakpoints.values.lg}px)`);
  const componentName = props.componentName || '';
  const isTicketCampaign = !!applyCampaignValidation && componentName === TicketBookingLocator;

  const {
    startDate,
    endDate,
    endDateName,
    startDateName,
    fieldLabel,
    validationMessage,
    showError,
    eventCalender,
    isRequired,
    minStartDate,
    labelVariant,
    placeholderText,
  } = props.data;

  const [openToDate, setOpenToDate] = useState(isTicketCampaign ? new Date(campaignStart) : new Date());
  const [error, setError] = useState(false)

  useEffect(() => {
    setError(showError)
  }, [showError])

  const campaingEndUTCDate = moment.utc(campaignEnd).format('YYYY-MM-DD');
  const campaingEndDate = new Date(campaingEndUTCDate)

  const handleMonthChange = (date) => {
    setOpenToDate(date);
  };

  const handleYearChange = (date) => {
    setOpenToDate(date);
  };

  const handleDateChange = (date, type, props) => {
    if (type === 'start') {
      // check if "date" month is one month after the openToDate month
      if (moment(date).isAfter(openToDate, 'month')) {
        if (isTicketCampaign) {
          const element = document.getElementsByClassName('react-datepicker__current-month')
          const openMonth = element[0].innerHTML.split(' ')
          if (openMonth[0] && openMonth[1]) {
            const month = moment().month(openMonth[0]).format('MM')
            const dateString = `${openMonth[1]}/${month}/03`
            const getDate = new Date(dateString)
            setOpenToDate(getDate)
          }
        } else {
          // setOpenToDate to on month before the selected date
          setOpenToDate(moment(date).subtract(1, 'month').toDate());
        }
      } else {
        setOpenToDate(date);
      }
      onStartDateChange(date, props);
    } else {
      onEndDateChange(date, props);
    }
  };

  var startDateCalendar = useRef(null);
  var endDateCalendar = useRef(null);
  const openEndDateCalendar = () => endDateCalendar.setOpen(true);
  const openStartDateCalendar = () => startDateCalendar.setOpen(true);
  const onStartDateChange = (date, props) => {
    let target = {};
    const { data } = props;
    target.name = data && data.startDateName && data.startDateName.value;
    if (date) {
      target.value = date;
    } else {
      target.value = '';
    }
    props.onDateChange({ target: target });
    openEndDateCalendar();
  };
  const onEndDateChange = (date, props) => {
    // Check if the end date is the same as the start date
    if (startDate.value && date && moment(date).isSame(startDate.value, 'day') && props.shouldSetMinDate) {
      setError(true)
      return; // Do not update the end date if it's the same as the start date
    }

    let target = {};
    const { data } = props;
    target.name = data && data.endDateName && data.endDateName.value;
    if (date) {
      target.value = date;
    } else {
      target.value = '';
    }
    setError(false)
    props.onDateChange({ target: target });
  };

  const onEndDateCalendarClose = () => {
    if (!(!!endDate.value)) {
      setError(true)
      props.onDateChange({ target: { name: props.data.startDateName.value, value: '' } });
    }
  }

  const CustomInputStartDate = React.forwardRef((props, ref) => {
    return (
      <input
        id={startDateName && startDateName.value}
        name={startDateName && startDateName.value}
        ref={ref}
        className={classes.datePicker}
        label={fieldLabel && fieldLabel.value}
        defaultValue={
          startDate && startDate.value
            ? moment(startDate.value).format('YYYY-MM-DD')
            : ''
        }
      />
    );
  });
  const CustomInputEndDate = React.forwardRef((props, ref) => {
    return (
      <input
        id={endDateName && endDateName.value}
        ref={ref}
        name={endDateName && endDateName.value}
        className={classes.datePicker}
        label={fieldLabel && fieldLabel.value}
        defaultValue={
          endDate && endDate.value
            ? moment(endDate.value).format('YYYY-MM-DD')
            : ''
        }
      />
    );
  });

  const renderLabel = () => {
    const label = (
      <div className={classes.customPlaceholder}>
        <Text field={placeholderText} />
      </div>
    );
    if (!eventCalender && !startDate.value) {
      return label;
    } else if (eventCalender && !startDate.value && !endDate.value) {
      return label;
    } else {
      return null;
    }
  };

  return (
    <FormControl
      component="fieldset"
      className={classes.root}
      aria-label={fieldLabel && fieldLabel.value}
    >
      <legend />
      <div className={classes.rangeCalendar}>
        <div className={clsx(classes.CalendarWrapper, 'calendarWrapper',
          { 'date-selected': startDate && startDate.value })}
        >
          <DatePicker
            onChange={date => handleDateChange(date, 'start', props)}
            selectsStart
            selected={startDate && startDate.value}
            disabledKeyboardNavigation={isTicketCampaign}
            startDate={startDate && startDate.value}
            endDate={endDate && endDate.value}
            className={classes.datePicker}
            monthsShown={isMobile ? 1 : 2}
            id={startDateName && startDateName.value}
            name={startDateName && startDateName.value}
            ref={c => (startDateCalendar = c)}
            popperPlacement={props.position}
            customInput={<CustomInputStartDate />}
            minDate={isTicketCampaign ? new Date(campaignStart) :
              props.shouldSetMinDate
                ? minStartDate && minStartDate.value || new Date()
                : ''
            }
            maxDate={isTicketCampaign ? campaingEndDate :
              props.maxDateYearCount
                ? getYearsAddedToDate(new Date(), props.maxDateYearCount)
                : ''
            }
            onMonthChange={handleMonthChange}
            onYearChange={handleYearChange}
            {...props}
          />
          <CalendarTodayIcon className="calendarIcon" />
        </div>
        {startDate && (
          <div className={clsx(classes.CalendarWrapper, classes.endDate, 'calendarWrapper',
            { 'date-selected': endDate && endDate.value })}
          >
            <DatePicker
              onChange={date => handleDateChange(date, 'end', props)}
              selectsEnd
              selected={isMobile ? startDate && startDate.value : endDate && endDate.value}
              startDate={startDate && startDate.value}
              endDate={endDate && endDate.value}
              minDate={startDate && startDate.value}
              maxDate={isTicketCampaign ? campaingEndDate : ''}
              className={classes.datePicker}
              ref={c => (endDateCalendar = c)}
              openToDate={openToDate}
              monthsShown={isMobile ? 1 : 2}
              onCalendarClose={onEndDateCalendarClose}
              id={endDateName && endDateName.value}
              name={endDateName && endDateName.value}
              popperPlacement={props.position}
              customInput={<CustomInputEndDate />}
              {...props}
            />
            <CalendarTodayIcon className={classes.calendarIcon} />
          </div>
        )}
        <div
          className={clsx(classes.rangeCalendarPicker, 'rangeCalendarPicker')}
          onClick={() => openStartDateCalendar()}
        >
          <label
            className={
              isObject(startDate.value) || isObject(endDate && endDate.value)
                ? classes.labelFilled
                : 'default-shrink'
            }
            htmlFor={startDateName && startDateName.value}
          >
            <Typography
              variant={labelVariant || variantType}
              component={'span'}
              gutterBottom={false}
            >
              <Text field={fieldLabel} />
            </Typography>
            {isRequired && isRequired.value && <span> *</span>}
          </label>
          {(isObject(startDate.value) || isObject(endDate.value)) && (
            <Typography
              variant={variantType}
              component={variantType}
              gutterBottom={false}
            >
              <Text
                field={{
                  value: `${isObject(startDate.value) ? moment(startDate.value).format('DD/MM/YYYY') : ''
                    } - ${isObject(endDate.value) ? moment(endDate.value).format('DD/MM/YYYY') : ''
                    }`,
                }}
              />
            </Typography>
          )}
          {renderLabel()}
          <CalendarTodayIcon className="calendarIcon" />
        </div>
      </div>
      {error && (
        <div className={classes.errorMsg}>
          {renderText(
            validationMessage &&
            validationMessage.fields &&
            validationMessage.fields.displayText, labelVariant
          )}
        </div>
      )}
    </FormControl>
  );
};

const Calender = props => {
  const { componentName } = props
  // const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  const isMobile = useMediaQuery(`(max-width:${breakpoints.values.lg}px)`);
  let language = get(props, 'sitecoreContext.language', '');
  language = language && language.toLowerCase();
  return (
    <React.Fragment>
      {props.monthsShown === 2 || (props.data && props.data.eventCalender) ? (
        <RangeDatePicker
          monthsShown={
            isMobile ? 1 : props.monthsShown || props.data.monthsShown
          }
          data={props.data}
          isEventCalendar={props.data.eventCalender}
          onDateChange={props.onChange}
          position={language === 'ar' || language === 'he' ? 'bottom-end' : 'bottom-start'}
          shouldSetMinDate={props.shouldSetMinDate}
          maxDateYearCount={props.maxDateYearCount}
          componentName={componentName}
        />
      ) : (
        <SingleDatePicker
          monthsShown={isMobile ? 1 : props.monthsShown}
          data={props.data}
          isEventCalendar={props.data.eventCalender}
          onDateChange={props.onChange}
          position={language === 'ar' || language === 'he' ? 'bottom-end' : 'bottom-start'}
          shouldSetMinDate={props.shouldSetMinDate}
          maxDateYearCount={props.maxDateYearCount}
        />
      )}
    </React.Fragment>
  );
};

export default withSitecoreContext()(Calender);